import { NAV } from "@/constants/testIds";

const messages = [
  "FREE UK DELIVERY OVER £75",
  "FAILURE IS PART OF THE PROCESS",
  "MADE TO ORDER · SHIPPED WITH CARE",
  "JOIN THE DTA COMMUNITY",
];

export default function AnnouncementBar() {
  const track = [...messages, ...messages, ...messages];
  return (
    <div
      className="w-full bg-[#0A0A0A] text-white border-b border-[rgba(255,255,255,0.08)] overflow-hidden"
      data-testid={NAV.announcementBar}
    >
      <div className="dta-container py-2.5">
        <div className="marquee-track dta-overline text-[0.68rem]">
          {track.map((m, i) => (
            <span key={i} className="inline-flex items-center gap-6">
              <span>{m}</span>
              <span className="opacity-40">/</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
